<template>
	<div>
		<el-dialog title="修改" width="600px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm"
			append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">

				<el-row>
					<el-col :span="24">
						<el-form-item label="教练名" prop="trainer_name">
							<el-input v-model="form.trainer_name" autoComplete="off" clearable
								placeholder="请输入用户名"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="手机号" prop="trainer_phone">
							<el-input v-model="form.trainer_phone" autoComplete="off" clearable
								placeholder="请输入手机号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="提成比列" prop="commission">
							<el-input v-model="form.commission" autoComplete="off" clearable
								placeholder="最小0最大100"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="上级代理：">
							<el-select style="width: 160px;" size="small" v-model="form.pid" placeholder="请选择">
								<el-option v-for="type in type" :label="type.trainer_name" :value="type.trainer_user_id"
									:key="type.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="抖音平台" prop="is_dy">
							<el-radio-group v-model="form.is_dy">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="快手平台" prop="is_ks">
							<el-radio-group v-model="form.is_ks">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="微信平台" prop="is_wx">
							<el-radio-group v-model="form.is_wx">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="是否禁用" prop="disable">
							<el-radio-group v-model="form.disable">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getTraineredit,getPid } from '../../api/userMG';

export default {
	name: 'bannerupdate',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
		info: {
			type: Object,
		},
	},
	data() {
		return {
			form: {
				trainer_user_id: '',
				disable: 0,
				trainer_name: '',
				trainer_phone: '',
				pid:''
			},
			type:[],
			loading: false,
			rules: {
			}
		}
	},
	methods: {
		open() {
			this.form = this.info
			this.form.type = 'set'
			getPid().then(res=>{
				console.log(res);
				this.type = res.trainer
				
			})
		},
		submit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					console.log(this.form);
					getTraineredit(this.form).then(res => {
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						}else{
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped ></style>



// WEBPACK FOOTER //
// src/views/coach/update.vue